import { render, staticRenderFns } from "./CaughtUpMessage.vue?vue&type=template&id=1a8552c4"
import script from "./CaughtUpMessage.vue?vue&type=script&lang=js"
export * from "./CaughtUpMessage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports